import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';

@Component({
    selector: 'app-driver-finish-confirmation',
    templateUrl: './driver-finish-confirmation.component.html',
    styleUrls: ['./driver-finish-confirmation.component.scss']
})
export class DriverFinishConfirmationComponent extends BaseFormComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _toasterService: ToasterService,
        public _dialogRef: MatDialogRef<DriverFinishConfirmationComponent>) {
        super();
    }


    public async ngOnInit(): Promise<void> {

    }


    public async save(): Promise<void> {
        this.added.emit();
    }

}
